import { landownerSchema } from '@/routes/landowner/zodSchemas';
import { fieldReportSchema } from '@/routes/measurement-group/field-report/fieldReportSchema';
import { Path } from 'react-hook-form';
import { z } from 'zod';

const itemSchema = z.object({
	value: z.string(),
	label: z.string()
});

const deployDeviceUploadSchema = z
	.object({
		processObjectId: z
			.string({ message: 'A process object ID must be selected.' })
			.trim()
			.nonempty({ message: 'A process object ID must be selected.' }),
		title: z
			.string({ message: 'Title is required.' })
			.trim()
			.nonempty({ message: 'The title must contan at least 1 character' }),
		description: z
			.string({ message: 'Description is required.' })
			.trim()
			.nonempty({ message: 'The description must contan at least 1 character' }),
		file: z.instanceof(File, { message: 'A valid file must be uploaded.' }).optional()
	})
	.refine(data => data.file != null, { message: 'A valid file must be uploaded.', path: ['file'] });

export const landownerWithoutSiteSchema = landownerSchema.omit({ site: true });
const fieldReportWithoutPoSchema = fieldReportSchema.omit({
	poId: true
});

export const deployDeviceSchema = z.object({
	deploymentSiteId: z.array(itemSchema).nonempty('Site is required'),
	deviceId: z.array(itemSchema).nonempty('Device ID is required'),
	antennaTypeId: z.array(itemSchema).nonempty('Antenna type is required'),
	pvPanelTypeId: z.array(itemSchema).nonempty('PV panel type is required'),
	landownerExists: z.boolean(),
	existingLandownerId: z.array(itemSchema).optional(),
	landowner: landownerWithoutSiteSchema,
	upload: deployDeviceUploadSchema,
	fieldReport: fieldReportWithoutPoSchema
});

export type DeployDeviceFormSchemaType = z.infer<typeof deployDeviceSchema>;

export const stepFields: Record<number, Path<DeployDeviceFormSchemaType>[]> = {
	0: ['deploymentSiteId', 'deviceId', 'antennaTypeId', 'pvPanelTypeId'],
	1: [
		'landowner.firstName',
		'landowner.lastName',
		'landowner.streetAddress',
		'landowner.city',
		'landowner.state',
		'landowner.zip',
		'landowner.email',
		'landowner.phone',
		'landowner.mobile',
		'landowner.status',
		'landowner.initialPayment',
		'landowner.recurringPayment',
		'landowner.latitude',
		'landowner.longitude',
		'landowner.initialDeploymentDate'
	],
	2: ['upload.processObjectId', 'upload.title', 'upload.description', 'upload.file'],
	3: [
		'fieldReport.performedAt',
		'fieldReport.deploymentTypeId',
		'fieldReport.notes',
		'fieldReport.hasExternalAntennas',
		'fieldReport.swapReason'
	]
};
